"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendViewProductsToGA = void 0;
const services_1 = require("../../services");
const _1 = require("./");
function sendViewProductsToGA({ products, category, subCategory, filter, }) {
    let list = '';
    if (subCategory || filter) {
        list = `${subCategory}-${filter}` || 'todos';
    }
    const impressions = products.map((product, index) => {
        const impression = {
            name: product.name,
            variant: product.name,
            id: product.sku.toString(),
            price: product.salePrice,
            brand: product.brand,
            dimension6: product.price !== product.discountPrice ? 'promo' : 'regular',
            dimension12: (0, _1.tagPromptDelivery)(product.tags),
            dimension18: (0, _1.tagResellerPrice)(product.tags),
            dimension16: product.availability.available ? 'disponivel' : 'indisponivel',
            position: index + 1,
            category: category,
        };
        if (list) {
            impression.list = list;
        }
        return impression;
    });
    const dataLayer = {
        event: 'productImpression',
        'event-category': 'productImpressions',
        'event-action': 'view',
        ecommerce: {
            impressions,
        },
    };
    services_1.GoogleAnalyticsService.event(dataLayer);
}
exports.sendViewProductsToGA = sendViewProductsToGA;
